import React from 'react';

const NonAccess = () => {
    return (
        <div className={'card mt-3'}>
            <div className="card-header">

            </div>
            <div className="card-body text-center">
                    <i className="fas fa-ban fa-2x text-danger my-3"></i>
                    <h5 className={"text-dark"}>Votre statut actuel ne vous permet pas <br/> d'accéder à cette section !</h5>
            </div>
        </div>
    );
};

export default NonAccess;
